<h2 mat-dialog-title>Add Data</h2>
<mat-dialog-content>
  <div
    class="add-data-container"
    [ngClass]="{ underDrag: isDragOver }"
    file-dropzone
    file-to-upload="file"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
      <input #uploadFeature type="file" id="uploadFile" class="d-none" accept=".kml, .kmz, .zip, .wkt, .geojson" (change)="onFileInputChange($event)" />
      <div class="dropzone" [ngClass]="{ hidden: isDragOver }">
      <mat-icon class="icon">backup</mat-icon>
      <span class="label">
        Drag files here or
        <span class="link-btn" for="uploadFile" (click)="selectFile()">browse</span>
      </span>
    </div>
    <div class="pulsating-circle" [ngClass]="{ hidden: !isDragOver }"></div>
    <div class="drag-over-text" [ngClass]="{ hidden: !isDragOver }">
      <mat-icon>backup</mat-icon>
      <span>Drop your files to upload</span>
    </div>
  </div>

  <!--Message upload panel -->
  <div class="tip" *ngIf="!isDragOver">
    <div class="tip-title">The following file types are supported. Each must be in WGS 84 (EPSG: 4326) and under 20 MB.</div>
    <span>1) A Shapefile formatted as a .zip file</span>
    <span>2) A .kml or .kmz file</span>
    <span>3) A .WKT file</span>
    <span>4) A .GeoJSON file</span>
    <span>Note: Imported boundary files must contain a single polygon. Multiple polygons are not supported.</span>
  </div>
  <hr class="line-padding" *ngIf="!isDragOver" />
  <!--File upload panel -->
  <div *ngIf="!isDragOver">
    <div class="auth-field add-layer-dialog upload-layer-height">
      <mat-form-field>
        <mat-label>Import Data</mat-label>
        <mat-select [(value)]="boundaryType" (selectionChange)="onChangeDataType()">
          <mat-option value="WKT">WKT</mat-option>
          <mat-option value="GeoJSON">GeoJSON</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <form [formGroup]="form">
      <mat-form-field *ngIf="boundaryType === 'WKT' || boundaryType === 'GeoJSON'" class="w-100">
        <textarea matInput rows="5" [placeholder]="'Paste ' + boundaryType + ' text'" formControlName="wkt" (input)="checkText()"></textarea>
      </mat-form-field>
      <mat-icon matSuffix class="text-success" *ngIf="isBoundaryValid">done</mat-icon>
    </form>
    <mat-label *ngIf="!isBoundaryValid" #lblError id="lblError"></mat-label>
    <hr *ngIf="errorMessage" />
    <div class="progress-line-label upload-error" *ngIf="errorMessage">{{ errorMessage }}</div>
  </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="!isDragOver" [ngClass]="{ hidden: isDragOver }">
  <button matButton="elevated"  (click)="closeDialog()">Cancel</button>
  <button matButton="elevated"  (click)="addFeature()" (keyup.enter)="addFeature()" [mat-dialog-close]="true" [disabled]="!isBoundaryValid">
    Add
  </button>
</mat-dialog-actions>
